import React from 'react'
import PropTypes from 'prop-types'
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'

function intInputParser(val) {
  const parsedInput = parseInt(val, 10)
  if (Number.isNaN(parsedInput)) {
    return 0
  }
  return parsedInput
}

function floatInputParser(val) {
  const parsedInput = parseFloat(val)
  if (Number.isNaN(parsedInput)) {
    return 0
  }
  return parsedInput
}

const EMPTY_COMMUNITY = {
  name: '',
  organization_id: '',
  location: {
    address: '',
  },
}

class CommunityFormDialog extends React.Component {
  static propTypes = {
    community: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }

  state = EMPTY_COMMUNITY

  componentDidMount() {
    const { community } = this.props

    if (Object.keys(community).length) {
      this.setState({ ...community })
    } else {
      this.setState(EMPTY_COMMUNITY)
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.currentTarget.value,
    })
  }

  handleLocationChange = (e) => {
    const { name, value } = e.target
    this.setState((prevState) => ({
      location: {
        ...prevState.location,
        [name]: value,
      },
    }))
  }

  handleSubmit = () => {
    // eslint-disable-next-line camelcase
    const { organization_id } = this.state
    const { latitude, longitude } = this.state.location
    const community = {
      ...this.state,
      location: { ...this.state.location },
    }

    community.organization_id = intInputParser(organization_id, 10)

    if (latitude || latitude === '') {
      community.location.latitude = floatInputParser(latitude)
    }

    if (longitude || longitude === '') {
      community.location.longitude = floatInputParser(longitude)
    }

    this.props.onSubmit(community)
    this.props.onClose()
  }

  getDialogTitle = () => {
    if (this.props.community.id) {
      return `Edit Community ${this.props.community.id}`
    }

    return 'Add Community'
  }

  render() {
    return (
      <Dialog open onClose={this.props.onClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{this.getDialogTitle()}</DialogTitle>
        <DialogContent>
          <div>
            <TextField
              label="Community Name"
              name="name"
              onChange={this.handleChange}
              required
              value={this.state.name}
            />
          </div>
          <div>
            <TextField
              label="Organization ID"
              name="organization_id"
              onChange={this.handleChange}
              type="number"
              value={this.state.organization_id}
            />
          </div>
          <div>
            <TextField
              name="address"
              label="Address"
              onChange={this.handleLocationChange}
              value={this.state.location.address}
            />
          </div>
          <div>
            <TextField
              label="Latitude"
              name="latitude"
              onChange={this.handleLocationChange}
              type="number"
              value={this.state.location.latitude || ''}
            />
            <TextField
              label="Longitude"
              name="longitude"
              onChange={this.handleLocationChange}
              type="number"
              value={this.state.location.longitude || ''}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} variant="contained" color="secondary">
            Cancel
          </Button>
          <Button onClick={this.handleSubmit} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default CommunityFormDialog
